import { Component, type OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message, Thread } from 'src/app/core/models/comms.model';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { CommunicationService } from 'src/app/core/services/communication.service';
import { UserService } from 'src/app/core/services/user.service';
import { ToastService } from 'angular-toastify';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-new-communication',
  templateUrl: './new-communication.component.html',
  styleUrls: ['./new-communication.component.scss'],
})
export class NewCommunicationComponent implements OnInit {
  claimId: string = '';
  user: any;
  thread: Thread | undefined;
  message: Message | undefined;
  phone?: string;
  email?: string;

  withoutCase: boolean = false;

  loading: boolean = false;

  subjectError: 'SubjectBlankError' | 'SubjectTooLongError' | '' = '';
  messageError: 'MessageBlankError' | 'MessageTooLongError' | '' = '';

  readonly SUBJECT_MAX_LENGTH = 60;
  readonly MESSAGE_MAX_LENGTH = 4000;

  constructor(
    private router: Router,
    private cs: CommunicationService,
    private activatedRoute: ActivatedRoute,
    private us: UserService,
    private cls: ClaimsService,
    private toast: ToastService,
    private translateService: TranslateService
  ) {}
  async ngOnInit(): Promise<void> {
    console.log('New Communication Component =< Hello');
    // Get claim ID from URL
    const claimId = this.activatedRoute.snapshot.paramMap.get('claim');
    console.log('claimId', claimId);
    if (claimId !== 'new') {
      this.claimId = claimId ?? '';
      if (!this.claimId) {
        this.router.navigate(['/client']);
      }

      this.cls.getClaimWithCase(this.claimId).then((e) => {
        this.phone = e.cp_case.attributes?.contact?.phone;
        this.email = e.cp_case.attributes?.contact?.email;
      });
    } else {
    }
    this.user = await this.us.getCurrentUser();

    this.thread = this.createNewThread();
    this.message = this.createNewMessage();
  }
  createNewThread(): Thread {
    const newThread: Thread = {
      medium: 'INTERNAL_MESSAGE',
      related_claim_id: this.claimId,
      open_for_replies: true,

      subject: '',
      started_by_user_id: this.user?.id ?? '-',

      attributes: {},
      language: '',
      started_at: new Date(),
    };

    return newThread;
  }
  createNewMessage(): Message {
    const newMessage: Message = {
      value: '',
      thread_id: '',
      author_user_id: this.user?.id ?? '-',

      type_message: 'INTERNAL_MESSAGE',
      author_display_name: '',
      attachments: {},
      user_agent: {},
      metadata: {},
      user_reads: [],
    };

    return newMessage;
  }

  async saveThread(): Promise<void> {
    this.clearErrors();

    if (!this.validateForm()) {
      return;
    }

    this.loading = true;
    try {
      const resThread = await this.cs.create(this.thread!);
      console.log('resThread', resThread);

      this.message!.thread_id = resThread.id ?? '';
      const resMessage = await this.cs.sendMessage(this.message!);
      console.log('resMessage', resMessage);

      this.toast.success(this.translateService.instant('MessageSent'));
      this.router.navigate(['/client/claim/' + this.claimId]);
    } catch (error) {
      console.error('Error sending message:', error);
      this.toast.error(this.translateService.instant('MessageSendError'));
    } finally {
      this.loading = false;
    }
  }

  private validateForm(): boolean {
    let isValid = true;

    if (!this.thread?.subject || this.thread.subject.trim() === '') {
      this.subjectError = 'SubjectBlankError';
      isValid = false;
    } else if (this.thread.subject.length > this.SUBJECT_MAX_LENGTH) {
      this.subjectError = 'SubjectTooLongError';
      isValid = false;
    }

    if (!this.message?.value || this.message.value.trim() === '') {
      this.messageError = 'MessageBlankError';
      isValid = false;
    } else if (this.message.value.length > this.MESSAGE_MAX_LENGTH) {
      this.messageError = 'MessageTooLongError';
      isValid = false;
    }

    return isValid;
  }

  private clearErrors(): void {
    this.subjectError = '';
    this.messageError = '';
  }

  onSubjectChange(): void {
    this.subjectError = '';
    if (
      this.thread?.subject &&
      this.thread.subject.length > this.SUBJECT_MAX_LENGTH
    ) {
      this.subjectError = 'SubjectTooLongError';
    }
  }

  onMessageChange(): void {
    this.messageError = '';
    if (
      this.message?.value &&
      this.message.value.length > this.MESSAGE_MAX_LENGTH
    ) {
      this.messageError = 'MessageTooLongError';
    }
  }

  get isFormValid(): boolean {
    return !!(
      this.thread?.subject?.trim() != null &&
      this.message?.value?.trim() != null &&
      this.thread.subject.length <= this.SUBJECT_MAX_LENGTH &&
      this.message.value.length <= this.MESSAGE_MAX_LENGTH
    );
  }
}
